import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { CONTAIN_OPTION, INITIAL_OPTION } from "../../../foundations/constants.es.js";
import { FILTER_GRAYSCALE } from "../utils/product-card.constants.es.js";
const ImageSection = styled("img", styledOptions)(({
  disabled
}) => ({
  objectFit: CONTAIN_OPTION,
  filter: disabled ? FILTER_GRAYSCALE : INITIAL_OPTION
}));
export {
  ImageSection
};
//# sourceMappingURL=image-section.es.js.map
